import type { DruidAndFilter } from '../../../../../../../server/modules/druid';
import type { Filter } from '../../../../../main/types/druidTypes';

export type AndType = 'and';

export default class AndFilter implements DruidAndFilter {
  dimension: void;

  field: void;

  fields: Filter[];

  pattern: void;

  type: AndType;

  values: void;

  constructor(fields: Filter[]) {
    this.type = 'and';
    this.fields = fields ? fields : [];
  }
}
